module.exports = __webpack_public_path__ + "img/digital_marketing.3f74ff0d.webp";